import { render, staticRenderFns } from "./PanelGoldConfig.vue?vue&type=template&id=0185d926&scoped=true&"
import script from "./PanelGoldConfig.vue?vue&type=script&lang=js&"
export * from "./PanelGoldConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185d926",
  null
  
)

export default component.exports